module.exports = __webpack_public_path__ + "img/express-jd.6e9e3ebf.png";